import { Box } from "@mui/material"
import { MapDrawerWidth } from "../../atom/atom"
import {
    useSetRecoilState,
} from 'recoil';

export default function DrawerHandle() {
    const setDrawerWidth = useSetRecoilState(MapDrawerWidth)
    function handleMouseDown(ev, handler) {
        onmousemove = (ev) => {
            setDrawerWidth(document.body.clientWidth - ev.clientX)
        }
        onmouseup = (ev) => {
            onmousemove = null
            onmouseup = null
        }
    }

    return (
        <Box
        sx={{
            float: "left",
            width: "4px",
            backgroundColor: "#fff",
            opacity: 0,
            height: "100%",
            cursor: "ew-resize",
            "transition": "background-color 100ms linear",
            "&:hover": { backgroundColor: "sdeBlue.main", "transition": "background-color 100ms linear", opacity: 1 }
        }}
        onMouseDown={ handleMouseDown }
        />
    )
}